// src/components/TermsModal.js
import React from "react";
import "./TermsModal.css";

const TermsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Apna Card – Terms & Conditions & Usage Guidelines</h2>
        <p>
          Thank you for choosing Apna Card, Pakistan’s first integrated Health &
          Fintech Smart Card that connects users with trusted healthcare,
          wellness, and financial partners. Please read these Terms & Conditions
          carefully before registration or use.
        </p>

        <hr />
        <h3>1. Card Purchase & Registration</h3>
        <ul>
          <li>
            The Apna Card is available for PKR 2,000, and can be purchased
            online through our official website or from Apna Card registered
            partner outlets.
          </li>
          <li>
            For registration, users are required to provide:
            <ul>
              <li>Full Name</li>
              <li>Contact Number</li>
              <li>Date of Birth</li>
              <li>CNIC Number</li>
              <li>Postal Address</li>
              <li>Email Address</li>
            </ul>
          </li>
          <li>
            Apna Card reserves the right to verify all information provided at
            the time of registration.
          </li>
        </ul>

        <h3>2. Card Usage</h3>
        <ul>
          <li>
            The Apna Card is non-transferable and can only be used by the
            registered member.
          </li>
          <li>
            Members can avail services, discounts, and benefits only at Apna
            Card registered partner providers.
          </li>
          <li>Discounts and benefits may change without prior notice.</li>
        </ul>

        <h3>3. Lost or Damaged Cards</h3>
        <ul>
          <li>
            Immediately notify Apna Card Support in case of loss or damage.
          </li>
          <li>
            Replacement cards will be issued after verification and payment of
            fees.
          </li>
        </ul>

        <h3>4. Validity & Renewal</h3>
        <ul>
          <li>Valid for one year from activation date.</li>
          <li>Renewal fee: PKR 1,000 per year.</li>
          <li>Failure to renew results in suspension of services.</li>
        </ul>

        <h3>5. User Responsibilities</h3>
        <ul>
          <li>Keep your card and login credentials safe.</li>
          <li>Fraudulent use may result in cancellation without refund.</li>
          <li>Keep your personal information updated.</li>
        </ul>

        <h3>6. Limitation of Liability</h3>
        <ul>
          <li>
            Apna Card connects users with third-party partners but does not
            guarantee services.
          </li>
          <li>
            Partners are solely responsible for service quality and delivery.
          </li>
          <li>
            Apna Card is not liable for any loss or dispute from third-party
            engagements.
          </li>
        </ul>

        <h3>7. Amendments</h3>
        <ul>
          <li>Apna Card may update terms and fees at any time.</li>
          <li>Updates will be available on the official website.</li>
        </ul>

        <h3>8. How to Use Your Apna Card</h3>
        <ol>
          <li>Open the Apna Card App or scan your card.</li>
          <li>Select your company name.</li>
          <li>Generate a discount code.</li>
          <li>Show the card and code before billing.</li>
          <li>Discount applies instantly on eligible services.</li>
        </ol>

        <p>
          🔹 <b>Important:</b> Always inform the counter staff before billing.
          Discounts cannot be applied after billing. Some referred internal
          services may already have discounts, hence additional Apna Card
          discounts may not apply.
        </p>

        <hr />
        <p>
          <b>Disclaimer:</b> Apna Card is a facilitation platform, not a
          hospital or bank. Terms and discounts are subject to change without
          notice.
        </p>

        <button className="close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default TermsModal;
